@if(displayMode===LoadingSpinnerDisplayMode.BLOCK){
<div class="{{overlayClass}} {{defaultHeightClass}}">
  <div class='spinner-container'>
    <ng-template [ngTemplateOutlet]="spinner"></ng-template>
  </div>
</div>
}
@else {
<ng-template [ngTemplateOutlet]="spinner"></ng-template>
}

<ng-template #spinner>
  <span class='spinner {{positionClass}} {{sizeClass}} {{colorSchemeClass}}'></span>
</ng-template>
